import React, { Component, Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Menu from '@material-ui/core/Menu';
import FilterIcon from '@material-ui/icons/FilterList';

class OptionDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchPhrase: null,
    };
  }

  checkboxInput(optionId, optionName) {
    const { hasId, toggleId } = this.props;
    const optionIdString = optionId.toString();

    return (
      <FormControlLabel
        control={
          <Checkbox
            checked={hasId(optionIdString)}
            onChange={() => toggleId(optionIdString)}
            value={optionIdString}
          />
        }
        label={optionName}
        key={optionIdString}
        style={{ 'padding-left': '10px' }}
      />
    );
  }

  renderOptions = (options, searchPhrase) => {
    return options
      .filter(
        (o) =>
          !searchPhrase ||
          o.name.toLowerCase().indexOf(searchPhrase.toLowerCase()) > -1,
      )
      .map((o) => this.checkboxInput(o.id, o.name));
  };

  render() {
    const { options, categoryName, selectAll, hasSearch } = this.props;
    const { anchor, searchPhrase } = this.state;

    return (
      <Fragment>
        <Button
          color="primary"
          aria-owns={categoryName}
          aria-haspopup="true"
          onClick={(e) => this.setState({ anchor: e.currentTarget })}
        >
          <FilterIcon style={{ marginRight: '7px' }} />
          {categoryName}
        </Button>
        <Menu
          id={categoryName}
          anchorEl={anchor}
          open={Boolean(anchor)}
          onClose={() => this.setState({ anchor: null, searchPhrase: null })}
        >
          <FormLabel>Filter by {categoryName}</FormLabel>
          <FormGroup>
            {selectAll && (
              <Button onClick={() => selectAll(true)}>Select All</Button>
            )}
            {selectAll && (
              <Button onClick={() => selectAll(false)}>Deselect All</Button>
            )}
            {hasSearch && (
              <TextField
                id="search"
                placeholder="Search..."
                onChange={(e) =>
                  this.setState({ searchPhrase: e.target.value })
                }
              />
            )}
            {this.renderOptions(options, searchPhrase)}
          </FormGroup>
        </Menu>
      </Fragment>
    );
  }
}

OptionDropdown.defaultProps = {
  hasSearch: true,
};

export default OptionDropdown;
